import { Box, Stack, Typography } from "@mui/material";
import { VolumeTypeEnum } from "../../../../../store/types/secureVolume.types";
import { DISPLAY_VOLUME_TYPES, VOLUME_TYPE_CONFIG, fmt, pctFmt } from "../types";
import { getSecuredPctColor } from "./SecuredIndicator";

export function VolumeTypeSummary({
  typeMap,
  securedPct,
}: {
  typeMap: Map<VolumeTypeEnum, number>;
  securedPct?: number | null;
}) {
  const entries = DISPLAY_VOLUME_TYPES.filter(
    (t) => typeMap.has(t),
  ).map((t) => ({ type: t, qty: typeMap.get(t)! }));

  if (entries.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  const showPct = securedPct !== undefined && securedPct !== null;

  return (
    <Stack spacing={0}>
      {entries.map(({ type, qty }) => {
        const isSecured = type === VolumeTypeEnum.Secured;
        return (
          <Box
            key={type}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: VOLUME_TYPE_CONFIG[type].color,
                flexShrink: 0,
              }}
            />
            <Typography variant="caption">{fmt.format(qty)}</Typography>
            {isSecured && showPct && (
              <Typography
                variant="caption"
                sx={{
                  color: getSecuredPctColor(securedPct),
                  fontWeight: 600,
                  ml: "auto",
                }}
              >
                {pctFmt.format(securedPct)}%
              </Typography>
            )}
          </Box>
        );
      })}
    </Stack>
  );
}
